import * as types from '../action/types'

const initialState = false
const isTokenCreationAuthorized = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_NEW_TOKEN_AUTH_STATE:
      return action.authorized
    default:
      return state
  }
}
export default isTokenCreationAuthorized
